function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2,58.2c-1.3,3.8-3.2,7.2-7.2,7.2s-7-3.2-7.2-7.2c-0.3-5.1,3.1-7.2,7.2-7.2C57.8,51,61.7,53.7,60.2,58.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 47.8,
  y: 57.3,
  fill: "#404547",
  width: 11,
  height: 17.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0BEC5",
  d: "M51.3,67.3c0,0,0.4,5.3-0.5,6.2s7.7,1.6,7.5,0.6c-0.1-1-1.7-7.4-1.2-8.8C57.6,64,51.3,67.3,51.3,67.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#8C9699",
  d: "M42.8,81l-4.5,15.3l-0.2,0.6h-7.6c3-9.4,10.5-23.2,10.5-23.2l1.2-0.3L42.8,81z"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  fill: "#B0BEC5",
  cx: 52.6,
  cy: 63.4,
  r: 5.7
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7,72.4c0,0-2,1.9-4.3,1.5c-2.3-0.4-3.2-3.1-3.2-3.1L49,72.4c0,0-0.6,4.5,2.3,5s7.1,0.6,7.9,0S58.7,72.4,58.7,72.4z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0BEC5",
  d: "M65.6,79.1l-0.4,1.2l-5.1,16.6h-22c0-0.2,0.1-0.4,0.1-0.6c0.3-2.4,0.1-8.3,0.1-8.8c0-0.5,2.1-13,2.6-13.9 c0.1-0.1,0.2-0.2,0.3-0.3c0.6-0.3,1.9-0.7,3.3-1c0,0,0,0,0,0c0.8-0.2,1.6-0.4,2.3-0.5h0c0.7-0.1,1.4-0.3,1.9-0.3 c0.3,0,0.5-0.1,0.8-0.1c0.1,0,0.2,0.1,0.3,0.4C50.1,72.5,50,74,50,74c0.2,0.2,0.4,0.4,0.6,0.5c0.5,0.4,1,0.7,1.6,0.9 c0.5,0.2,1,0.4,1.5,0.5h0c0.5,0.1,1.1,0.2,1.6,0.3c0.5,0.1,0.9,0,1.4,0h0c1.3-0.2,1.8-1.1,2.1-1.7c0-0.1,0.1-0.2,0.1-0.3 c0,0,0,0,0,0c0.1-0.3,0.1-0.6,0.2-0.5h0c0.2,0,3.1,2.5,5,4.1C64.9,78.5,65.6,79.1,65.6,79.1L65.6,79.1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#8C9699",
  d: "M65.2,80.3l-5.1,16.6h-2.1c0.2-0.3,0.3-0.6,0.2-0.9c-0.1-0.5,1.4-5.2,2.8-9.6c1.3-4,2.5-7.7,2.5-7.7l1.2,0.6 C64.7,79.2,64.9,79.6,65.2,80.3z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#B0BEC5",
  d: "M68.9,95.4c-0.2,0.1-0.2,0.8-0.2,1.6h-9.8c0.2-0.3,0.4-0.7,0.3-1.1c-0.1-0.4,0.9-5,1.9-9.5 c0.8-3.5,1.5-6.9,1.8-8.1c0.1-0.3,0.1-0.4,0.1-0.4l0.1,0.1l0,0l2.5,1.2l0,0c0,0,3.9,7.4,2.6,9.2C67,90.1,67,90.1,67.5,91 C68,91.8,69.4,95.2,68.9,95.4z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M50.8,56.2c0,0-0.1-0.3-2.4,0.5s-3.7,7.3-2.6,11.1c0.5,1.5,0.1,2.6-0.5,3.4c-2.3,2.9-1.4,7.2,2,8.7c0.1,0,0.2,0.1,0.3,0.1 l1.5,0.9c0,0-1.9-2.4-0.9-5.6c0.8-2.7,0.9-5.5,0.3-8.2c-0.1-0.5-0.2-0.9-0.4-1.4c-1.2-4.1-0.6-3.6,3.5-7.7c0,0,2.3,1.7,4.4,2.6 c2,0.9,3.8,1.7,2.3,4.7c-1.5,2.9-4.9,5.5-2.6,9.3c2.3,3.8,2.6,2.3,2.3,3.8l0,0L57.7,80l1.7-1.7l-1.2,2.3c0,0,3.8,0,4.9-2.9l0.6,0.6 c0,0,2.3-4.1-2-7.9c0,0-1.5-0.9,0.6-3.8c2-2.9,0.5-9.2-2.1-10.3C57.6,55.1,50.8,56.2,50.8,56.2z"
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 10.2,
  y1: 83.4,
  x2: 89,
  y2: 83.4
});

var _ref13 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#0F63F2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 10.2,
  y1: 83.4,
  x2: 31.3,
  y2: 83.4
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M34.1,87v3.2l-5.3-3.2c-0.1-0.1-0.2,0-0.3,0.1c0,0,0,0.1,0,0.1V94c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0l5.3-3.2v3.2 c0,0.1,0,0.1,0.1,0.1h1.6c0.1,0,0.1,0,0.1-0.1V87c0-0.1,0-0.1-0.1-0.1L34.1,87C34.1,86.9,34.1,86.9,34.1,87z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8,94.2h-1.5c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v-7c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h1.5c0.1,0,0.2,0.1,0.2,0.2 c0,0,0,0,0,0v7C21,94.2,20.9,94.2,20.8,94.2C20.8,94.2,20.8,94.2,20.8,94.2z M24.8,94.2h-1.5c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v-7 c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h1.5c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v7C25,94.2,25,94.2,24.8,94.2 C24.8,94.2,24.8,94.2,24.8,94.2L24.8,94.2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#0F63F2",
  d: "M9.7,87.1v7c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0l5.5-3.5c0.1-0.1,0.1-0.2,0.1-0.3c0,0,0,0-0.1-0.1 L10,86.9c-0.1-0.1-0.2,0-0.2,0.1C9.7,87,9.7,87,9.7,87.1z"
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 6.8,
  y1: 100.5,
  x2: 85.5,
  y2: 100.5
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#B0BEC5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 6.8,
  y1: 104.7,
  x2: 21.4,
  y2: 104.7
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 6.6,
  y: 47.8,
  fill: "none",
  stroke: "#B0BEC5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  width: 86.5,
  height: 49.2
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.9,
  cy: 49.7,
  r: 2.9
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M49.5,48.2c0-1.5,1.1-2.7,2.6-2.8c-0.1,0-0.2,0-0.3,0c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9c0.1,0,0.2,0,0.3,0 C50.6,50.8,49.5,49.6,49.5,48.2z"
});

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.416e9288.svg";
export { ForwardRef as ReactComponent };